module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/decorations/deco-lines-4-86e7e3097d819e5438dee0c34c4bf12a.svg";